
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';

/**
 * UYAP 5 oturum sınırı uyarısı. Tasarım vue-imza-app'teki OturumLimitiDialog'dan
 * aktarıldı; iki uygulamada aynı uyarı aynı görünsün.
 *
 * Bağlantı farkı: vue-imza-app bunu Vuex getter/action ile sürüyor. icrapro-app'te
 * `connectToUyap` diye bir store action YOK (bu uygulama yalnızca socket'e yayın
 * yapıyor, giriş işini vue-imza-app üstleniyor) ve src/store/index.ts .gitignore'da.
 * Bu yüzden durum v-model ile dışarıdan veriliyor.
 */
@Component({})
export default class OturumLimitiDialog extends Vue {
  @Prop({type: Boolean, default: false}) readonly value!: boolean;

  baglaniyor = false;

  get acik(): boolean {
    return this.value;
  }

  set acik(v: boolean) {
    // persistent dialog; kapatma yalnızca düğmelerden veya bağlantı gelince.
    if (!v) this.kapat();
  }

  get isUyapConnected(): boolean {
    return this.$store.getters.isUyapConnected;
  }

  // Arka plandaki kurtarma döngüsü bağlantıyı geri kurunca pencere kendiliğinden kapanır.
  @Watch('isUyapConnected')
  onBaglanti(bagli: boolean) {
    if (bagli && this.acik) {
      this.kapat();
    }
  }

  kapat() {
    this.$emit('input', false);
  }

  async simdiDene() {
    this.baglaniyor = true;
    try {
      // Bot kimliksiz giriş yapmaz ('eİcraPro bekleniyor'): önce kimlik imzacıya devredilir.
      await this.$store.dispatch('kimlikDevret', {neden: 'kullanici'});
      // Yeniden giriş isteği: sunucu bunu vue-imza-app'e relay eder, giriş orada yapılır
      // (yüksüz olay = görünür giriş).
      this.$socket.client.emit('connectToUyap');
      // Asıl kapanış isUyapConnected izleyicisinden gelir (socket 'uyapconnection').
      if (this.isUyapConnected) {
        this.kapat();
      }
    } catch (e) {
      // Dialog açık kalsın ki kullanıcı tekrar deneyebilsin.
      console.error('UYAP yeniden bağlantı denemesi başarısız.', e);
    } finally {
      this.baglaniyor = false;
    }
  }
}
